import { extractNumbers } from "./Common.js";
import { sitemapBase } from "./Sitemap.js";
/**---------------------------------------------
 * 東葛システムからデータ取得
 * 全ページで読み込む
 * グロバールメニュー用等
*-----------------------------------------------*/
export const initTokatsu = async (param = {}) => {
  const url = `https://tokatsu-system.com/api/v1.1/tokatsu/init`;
  console.log(`init`, url);

  try {
    const [response] = await Promise.all([
      axios.get(url, param),
    ]);
    const props = { ...response.data.res };
    return props;
  } catch (error) {
    console.log(`error`, error);
    throw error;
  }
};

export const GlobalHandler = {
  props:{},
  async init(){
    this.props = await initTokatsu();
    console.log(`Global init`,this.props);
    const sitemap =this.generateSitemap(sitemapBase);
    //PC番のみ フッターサイトマップ
    const footerSitemap = document.getElementById('footer-sitemap');
    footerSitemap?footerSitemap.innerHTML = this.Sitemap(sitemap):``;

    /**---------------------------------------------
     * SEO用 書き出し
    **-----------------------------------------------*/
    // const SEOs = [];
    // footerSitemap.querySelectorAll(`a`).forEach((v,k) => {
    //   SEOs.push(
    //     {
    //       "title":v.textContent,
    //       "url":v.getAttribute(`href`),
    //       "h1":v.textContent,
    //       "description":``,
    //     }

    //   );
    // });
    // console.log(`SEO`,SEOs);


    //PC番ヘッダーグローバルメニュー 自社式場
    const globalHeaderFacilitiesList = document.getElementById('gh-facilities');
    globalHeaderFacilitiesList?globalHeaderFacilitiesList.innerHTML = this.GhFacilities():``;
    //PC番ヘッダーグローバルメニュー 公営式場
    const globalHeaderFacilitiesPublicList = document.getElementById('gh-facilities-public');
    globalHeaderFacilitiesPublicList?globalHeaderFacilitiesPublicList.innerHTML = this.GhFacilitiesPublic():``;

    const globalFacilitiesList = document.getElementById('global-facilities-list');
    globalFacilitiesList?globalFacilitiesList.innerHTML = this.GlobalFacilitiesList():``;

    const globalFacilitiesPublicList = document.getElementById('global-facilities-public-list');
    globalFacilitiesPublicList?globalFacilitiesPublicList.innerHTML = this.GlobalFacilitiesPublicList():``;

    const facilitiesListIcon = document.getElementById('facilities-list-icon');
    facilitiesListIcon?facilitiesListIcon.innerHTML = this.FacilitiesListIcon():``;

    const facilitiesLists = document.querySelectorAll('[data-id="facilities-list"]');
    facilitiesLists?facilitiesLists.forEach(facilitiesList=>{
      facilitiesList.innerHTML = this.FacilitiesLists();
    }):``;

    const memberPriceLists = document.querySelectorAll('[data-id="member-price-list"]');
    memberPriceLists?memberPriceLists.forEach(memberPriceList=>{
      memberPriceList.innerHTML = this.MemberPriceList();
    }):``;

    //#wpadminbarと#gh-navが存在する場合
    const wpadminbar = document.getElementById('wpadminbar');
    const ghNav = document.getElementById('gh-nav');
    const wrapperCarousel = document.getElementById('wrapper-carousel');
    if(wpadminbar && ghNav){
      ghNav.style.margintop = `${wpadminbar.clientHeight}px`;
    }
    return this.props
  },
  FacilitiesListIcon(){
    const props = this.props
    return `${props["SJOs"].map(v=>{
      const name = v.saijo_CD =='1000'?v.SJO_name_HP:v["SJO_name_HP"].replace(/月のあかり家族葬/g, '');;
      return `
      <div class="facilitiy has-text-centered">
        <a href="/facility/?f=${v.SJO_slug}">
          <div class="is-flex is-flex-direction-column">
            <figure class="image-3by4">
              <img src="/assets/image/${v.SJO_slug}.webp" alt="" srcset="">
            </figure>
            <p class="has-text-grey mb-1">${v.SJO_name_HP}</p>
          </div>
        </a>
      </div>`
    }).join(``)}`;


  },
  generateSitemap(sitemapBase){
    const props = this.props;
    let result = {...sitemapBase};
    result.facilities.sub = props["SJOs"].map(v=>{
      let name = v.saijo_CD == "0401"?`家族葬の${v.SJO_ryak}`:`${v.SJO_name_HP}`;
      return {"path":`/facility?f=${v.SJO_slug}`,"name":name};
    });
    result["facilities-public"].sub = props["PUBs"].map(v=>{
      let name = v.saijo_CD == "0401"?`家族葬の${v.SJO_ryak}`:`${v.SJO_name_HP}`;
      return {"path":`/facility?f=${v.SJO_slug}`,"name":name};
    });
    return result;
  },
  ancher(data){
    return data.path==``?`<span class="has-text-weight-bold">${data.name}</span>`:`<a href="${data.path}">${data.name}</a>`;

  },
  Sitemap(sitemap){
    // console.log(`sitemap`,sitemap);
    return `
        <div class="columns">
          <!-- 1列目 -->
          <div class="column">
            <dl class="mb-4">
              <dt>${this.ancher(sitemap["top"])}</dt>
              <dt>${this.ancher(sitemap["about"])}</dt>
            </dl>

            <dl>
              <dt>${this.ancher(sitemap["plan"])}</dt>
              ${sitemap["plan"].sub.map(v=>{
                return `<dd>${this.ancher(v)}</dd>`;
              }).join(``)}
            </dl>
          </div>
          <!-- 2列目 -->
          <div class="column">
            <dl>
              <dt>${this.ancher(sitemap["facilities"])}</dt>
              ${sitemap["facilities"].sub.map(v=>{
                return `<dd>${this.ancher(v)}</dd>`;
              }).join(``)}
            </dl>

          </div>
          <!-- 3列目 -->
          <div class="column">
            <dl>
              <dt>${this.ancher(sitemap["facilities-public"])}</dt>
              ${sitemap["facilities-public"].sub.map(v=>{
                return `<dd>${this.ancher(v)}</dd>`;
              }).join(``)}
            </dl>
          </div>
          <!-- 4列目 -->
          <div class="column">
            <dl class="mb-4">
              <dt>${this.ancher(sitemap["before"])}</dt>
              ${sitemap["before"].sub.map(v=>{
                return `<dd>${this.ancher(v)}</dd>`;
              }).join(``)}
            </dl>
            <dl>
              <dt>${this.ancher(sitemap["after"])}</dt>
              <dt>${this.ancher(sitemap["posts"])}</dt>
              <dt>${this.ancher(sitemap["company"])}</dt>
              <dt>${this.ancher(sitemap["privacy"])}</dt>
              <dt>${this.ancher(sitemap["law"])}</dt>
            </dl>
          </div>

        </div>
    `;
  },
  convertSpaceToBr(str){
    return str.replace(/\s/g, '<br>');
  },
  //グローバルヘッダーメニュー 自社式場
  GhFacilities(){
    const props = this.props
    return `${props["SJOs"].map(v=>{
      let name = v.saijo_CD == "0401"?`家族葬の${v.SJO_ryak}※`:`${v.SJO_name_HP}`;
      if(v.saijo_CD =="1000"){
        name = `月のあかり家族葬 松戸営業所`;
      }
      return `<div style="width:15.7%;">
      <a href="/facility/?f=${v.SJO_slug}">
        <figure class="image-3by4"><img src="/assets/image/thumnail/${v.SJO_slug}.webp" alt=""></figure>
        <p class="has-text-centered mb-2 lh-14">${this.convertSpaceToBr(name)}</p>
      </a>
      </div>`;
    }).join(``)}
    <div style="width:15.7%;" class="is-flex is-align-content-flex-end is-flex-wrap-wrap">
      <p style="font-size:12px;width:100%;" class="mb-1">※月のあかり家族葬提携式場</p>
    </div>`
  },
  //グローバルヘッダーメニュー 公営斎場
  GhFacilitiesPublic(){
    const props = this.props
    return `${props["PUBs"].map(v=>{
      return `<div style="width:15.7%;">
      <a href="/facility/?f=${v.SJO_slug}">
        <figure class="image-3by4"><img src="/assets/image/thumnail/${v.SJO_slug}.webp" alt=""></figure>
        <p class="has-text-centered">${v.SJO_name_HP}</p>
      </a>
      </div>`;
    }).join(``)}`
  },
  //ページ内 自社式場
  GlobalFacilitiesList(){
    const props = this.props
    return `
    ${props["SJOs"].map(v=>{
      let name = v.saijo_CD == "0401"?`家族葬の${v.SJO_ryak}`:`${v.SJO_name_HP}`;
        return `<li><a href="/facility?f=${v.SJO_slug}">${name}</a></li>`
      }).join(``)}`;
  },
  GlobalFacilitiesPublicList(){
    const props = this.props
    return `
    ${props["PUBs"].map(v=>{
      let name = v.saijo_CD == "0401"?`家族葬の${v.SJO_ryak}`:`${v.SJO_name_HP}`;
      return `<li><a href="/facility?f=${v.SJO_slug}">${name}</a></li>`
    }).join(``)}`;
    },
  FacilitiesLists(){
    const props = this.props
    console.log(`FacilitiesLists props`,props);
    return `
        <h4 class="title is-serif is-5 has-text-centered mb-3 is-letter-spacing">式場施設一覧</h4>
        <table class="table" style="font-size:0.8em;margin:0 auto;">
          ${props.SJOs.map(v=>{
            let name = v.saijo_CD == "0401"?`家族葬の${v.SJO_ryak}`:`${v.SJO_name_HP}`;
            if(v.saijo_CD =="1000"){
              name = `月のあかり 松戸営業所`;
            }
            return `<tr>
            <td class="has-text-left"><a href="/facility/?f=${v.SJO_slug}">${name}</a></td>
            <td class="has-text-left">${v.SJO_address02}${v.SJO_address03}</td>
          </tr>`
          }).join(``)}
        </table>`;
  },
  MemberPriceList(){
    const props = this.props
    const slugs = {
      "flower":"花しらべ",
      "message":"花ことば",
      "oneday":"一日葬",
      "family":"家族葬",
    }
    const order = [
      "flower",
      "message",
      "oneday",
      "family",
    ];
    return `<h4 class="title is-serif is-5 has-text-centered mb-3 is-letter-spacing">葬儀プラン会員割引料金</h4>
    <p class="has-text-centered">ご葬儀プラン価格から<br class="is-hidden-tablet">最大10％割引でご案内いたします。</p>
    <div class="has-text-centered">
    ${order.map(v=>{
      return `<table id="table-member-price" class="table" style="margin:0 auto;">
      <thead>
        <tr>
          <th colspan="20" class="has-text-centered has-background-info has-text-white">${slugs[v]}</th>
        </tr>
        <tr>
          <th class="has-text-centered">プラン</th>
          <th class="has-text-centered">一般価格(税込)</th>
          <th class="has-text-centered">会員価格(税込)</th>
          <th class="has-text-centered">割引率</th>
        </tr>
      </thead>
      <tbody>
      ${props["FNPs_slugs"][v].map(vv=>{
        return `<tr>
        <td>${extractNumbers(vv.FNP_name)}</td>
        <td class="has-text-right">${(Number(vv.FNP_price_inc)).toLocaleString()}</td>
        <td class="has-text-right">${(Number(vv.FNP_price_member_inc)).toLocaleString()}</td>
        <td class="has-text-right">${vv.FNP_member_rate}%割引</td>
      </tr>
      `
      }).join(``)}
      </tbody>
    </table>`;
    }).join(``)}`
  },


}

// export const FacilitiesListIcon = {
//   props:{},
//   dom:null,
//   async init(){
//     this.dom = document.getElementById('facilities-list-icon');
//     if(!this.dom)return;

//     this.props = await initTokatsu();
//     console.log(`Icon init`,this.props);
//     this.render();

//   },
//   render(){
//     this.dom.innerHTML = this.template(this.props);
//   },
//   template(){
//     const props = this.props;
//     console.log(`iconlist`,props);

//     return `${props["SJOs"].map(v=>{
//       const name = v.saijo_CD =='1000'?v.SJO_name_HP:v["SJO_name_HP"].replace(/月のあかり家族葬/g, '');;
//       return `
//       <div class="facilitiy has-text-centered">
//         <a href="/facility/?f=${v.SJO_slug}">
//           <div class="is-flex is-flex-direction-column">
//             <figure class="image-3by4">
//               <img src="/assets/image/${v.SJO_slug}.webp" alt="" srcset="">
//             </figure>
//             <p class="has-text-grey mb-1">${v.SJO_name_HP}</p>
//           </div>
//         </a>
//       </div>`
//     }).join(``)}`;
//   }
// }